/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
// import borders from "assets/theme/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

// const { borderRadius } = borders;

/** Matches Taxonomy category card top strip (ConfigureTaxonomy / Taxonomy overview). */
const TAXONOMY_TABLE_HEAD_BG = "#F7F8FF";

const tableHead = {
  styleOverrides: {
    root: {
      // display: "block",
      padding: `${pxToRem(1)} ${pxToRem(1)} 0  ${pxToRem(1)}`,
      backgroundColor: TAXONOMY_TABLE_HEAD_BG,
      // borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
    },
  },
};

export default tableHead;
